<div class="container-fluid py-5">
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCardsTwo; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                <!-- {{ card.value }} -->
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                <!-- {{ card.value }} -->
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-tools">
    <div class="row text-center">
      <div class="col-12">
        <a
          [routerLink]="['/numbers']"
          class="btn btn-dark btn-sm btn-redirect"
        >
          Stripe
        </a>
        <a
          [routerLink]="['/numbers/finance/square']"
          class="btn btn-dark btn-sm btn-select"
        >
          Square
        </a>
        <a
          [routerLink]="['/numbers/finance/paypal']"
          class="btn btn-dark btn-sm btn-redirect"
        >
          Paypal
        </a>
      </div>
    </div>
  </div>
  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <a class="btn btn-dark btn-sm btn-refresh" (click)="getData()">
        <i class="fa-solid fa-arrow-rotate-right"></i>
      </a>
      <div class="flex-grow-1 text-center">
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(1)">
          Bank Accounts
        </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(2)">
          Payments
        </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(3)">
          Customers
        </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(4)">
          Payouts
        </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(5)">
          Disputes
        </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(6)">
          Refunds
        </a>
      </div>
      <div style="width: 40px"></div>
    </div>
  </div>

  <!-- Bank Accounts -->
  <h2 *ngIf="step == 1">Bank Accounts</h2>

  <div class="card shadow-sm" *ngIf="step == 1">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Account Type</th>
              <th>Bank Name</th>
              <th>Country</th>
              <th>Currency</th>
              <th>Holder Name</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of bankAccounts">
              <td>{{ item.accountType }}</td>
              <td>{{ item.bankName }}</td>
              <td>{{ item.country }}</td>
              <td>{{ item.currency.toUpperCase() }}</td>
              <td>{{ item.holderName }}</td>
              <td>{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Transactions -->
  <h2 *ngIf="step == 2">Payments</h2>

  <div class="card shadow-sm" *ngIf="step == 2">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Imported</th>
              <th>Payment Method</th>
              <th>Description</th>
              <th>Customer</th>
              <th>Date</th>
              <!-- <th>Refund date</th>
              <th>Reason for payment rejection</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of payments">
              <td>
                {{ item.totalMoney.currency.toUpperCase() }}
                {{ item.totalMoney.amount / 100 | number : "1.2-2"
                }}<!-- <span
                class="badge bg-success"
              >
                {{ item.status }}
              </span> -->
                <span
                  class="badge"
                  [ngClass]="
                    item.cardDetails.status == 'CAPTURED'
                      ? 'badge-success'
                      : 'badge-danger'
                  "
                >
                  {{ item.cardDetails.status }}
                </span>
              </td>
              <!-- {{ item.status ? "Active" : "Inactive" }} -->
              <td>{{ item.cardDetails.card.cardBrand }}</td>
              <td>{{ item.id }}</td>
              <td>
                {{ item.shippingAddress.firstName }}
                {{ item.shippingAddress.lastName }}
              </td>
              <!-- <td>{{ getCustomerName(item.customer) }}</td> -->
              <td>
                {{ item.createdAt | date : "dd/MM/yyyy HH:mm:ss" }}
              </td>
              <!-- <td>falta</td>
              <td>falta</td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Customers -->
  <h2 *ngIf="step == 3">Customers</h2>

  <div class="card shadow-sm" *ngIf="step == 3">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Creation</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of customers">
              <td>{{ item.familyName }} {{ item.givenName }}</td>
              <td>{{ item.emailAddress }}</td>
              <td>{{ item.phoneNumber }}</td>
              <td>
                {{ item.createdAt | date : "dd/MM/yyyy HH:mm:ss" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- payouts -->
  <h2 *ngIf="step == 4">Payouts</h2>

  <div class="card shadow-sm" *ngIf="step == 4">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Amount</th>
              <th>Destination</th>
              <th>Arrive by</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of payouts">
              <td>
                ${{ item.amountMoney.amount / 100 | number : "1.2-2" }}
                <span class="badge bg-success">
                  {{ item.status }}
                </span>
              </td>
              <td>{{ item.destination.type }}</td>
              <td>
                {{ item.updatedAt | date : "dd/MM/yyyy HH:mm:ss" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- disputes -->
  <h2 *ngIf="step == 5">Disputes</h2>

  <div class="card shadow-sm" *ngIf="step == 5">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <!-- <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Default Payment Method</th>
              <th>Creation</th>
            </tr> -->
          </thead>
          <tbody>
            <!-- <tr *ngFor="let item of customers">
              <td>{{ item.name}}</td>
              <td>{{ item.email}}</td>
              <td></td>
              <td>{{ item.created * 1000 | date : "dd/MM/yyyy HH:mm:ss" }}</td>
            </tr> -->
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Refunds -->
  <h2 *ngIf="step == 6">Refunds</h2>

  <div class="card shadow-sm" *ngIf="step == 6">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <!-- <thead class="thead">
            <tr>
              <th>Imported</th>
              <th>Type</th>
              <th>Description</th>
              <th>Creation date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of refunds">
              <td>
                {{ item.currency.toUpperCase() }}
                {{ item.amount / 100 | number : "1.2-2" }}
              </td>
              <td>{{ item.object }}</td>
              <td>{{ item.id }}</td>
              <td>{{ item.created * 1000 | date : "dd/MM/yyyy HH:mm:ss" }}</td>
            </tr>
          </tbody> -->
        </table>
      </div>
    </div>
  </div>
</div>
